import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';

const domRoot = document.getElementById('root');
if (domRoot) {
  const root = ReactDOM.createRoot(domRoot);
  root.render(<App />);
}
